// Generated by CoffeeScript 1.12.2
var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

define('models/participant',['require','backbone'],function(require) {
  var Model, Participant;
  Model = require('backbone').Model;

  /**
  	A model for handling participant results
  
  	@class Participants
  	@extends Backbone.Model
   */
  return Participant = (function(superClass) {
    extend(Participant, superClass);

    function Participant() {
      return Participant.__super__.constructor.apply(this, arguments);
    }

    Participant.prototype.idAttribute = "_id";

    Participant.prototype.urlRoot = function() {
      return GLOBALS.uris.api + "/participant";
    };

    Participant.prototype.defaults = {
      email: null,
      answers: [],
      time: {
        start: null,
        end: null
      }
    };

    Participant.prototype.parse = function(response, options) {
      if (_.isObject(response.data)) {
        return response.data;
      } else {
        return data;
      }
    };

    return Participant;

  })(Model);
});

